<template>
    <div class="page">
      <div class="head-title">
        <div class="left">
          <ul class="breadcrumb">
            <li><a href="#">{{ $t("sales") }}</a></li>
            <li>-</li>
            <li><a href="#">{{ $t("bills") }}</a></li>
            <li>-</li>
            <li><a class="active" href="#">{{ $t("update") }} {{ $t("bills") }}</a></li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="head">
          <div class="head1">
            <h3>{{ $t("update") }} {{ $t("bills") }}</h3>
          </div>
          <div class="head2">
            <button class="buttonconfirm" type="submit" :disabled="disabled || isRemoving" @click="submit">
              {{ $t("update") }}
            </button>
          </div>
        </div>
        <div class="body">
          <div class="part1">
            <div class="part11">
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("number") }}</label>
                <div class="col-sm-7">BILL-{{ id }}</div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("date") }} <span
                    class="error-feedback">{{ "*" }}</span></label>
                <div class="col-sm-7">
                  <input type="date" class="form-control form-control-sm" id="inputEmail3" v-model="date" />
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("description") }}</label>
                <div class="col-sm-7">
                  <input type="text" class="form-control form-control-sm" id="inputEmail3" v-model="description" />
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("supplier") }} <span
                    class="error-feedback">{{ "*" }}</span></label>
                <div class="col-sm-7">
                  <v-select :options="customers" label="name" v-model="sdata">
                    <template #option="option">
                      <span>{{ option.name }}</span>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("date") }} {{ $t("due") }} <span
                    class="error-feedback">{{ "*" }}</span></label>
                <div class="col-sm-7">
                  <input type="date" class="form-control form-control-sm" id="inputEmail3" v-model="duedate" />
                </div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-2 col-form-label-sm">{{ $t("number") }} {{ $t("invoice") }} <span
                    class="error-feedback">{{ "*" }}</span></label>
                <div class="col-sm-7">
                  <input type="text" class="form-control form-control-sm" id="inputEmail3" v-model="invnum" />
                </div>
              </div>
            </div>
            <div class="part12" style="padding: 2%;">
              <h4>{{ $t("data") }} {{ $t("project") }}</h4>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-3 col-form-label-sm">{{ $t("name") }} {{ $t("project") }}</label>
                <div class="col-sm-8">{{ project.name }}</div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-3 col-form-label-sm">{{ $t("name") }} {{ $t("owner") }}</label>
                <div class="col-sm-8">{{ project.ownername }}</div>
              </div>
              <div class="mb-2 row">
                <label for="inputEmail3" class="col-sm-3 col-form-label-sm">{{ $t("type") }} {{ $t("project") }}</label>
                <div class="col-sm-8">
                  <span v-if="project.ptype == 'inhouse'">مشروعات تحت التنفيذ</span>
                  <span v-if="project.ptype == 'other'">مشروعات الغير </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mb-2 row">
            <label for="inputEmail3" class="col-sm-1 col-form-label-sm">{{ $t("project") }} <span
                class="error-feedback">{{ "*" }}</span></label>
            <div class="col-sm-4">
              <v-select :options="allprojects" label="name" v-model="project">
                <template #option="option">
                  <span>{{ option.name }}</span>
                </template>
              </v-select>
            </div>
          </div>
          <div class="mb-2 row">
            <label for="inputEmail3" class="col-sm-1 col-form-label-sm">{{ $t("product") }}</label>
            <div class="col-sm-2">
              <v-select :options="products" label="namear" v-model="product">
                <template #option="option">
                  <span>{{ option.barcode }} - {{ option.namear }}</span>
                </template>
              </v-select>
            </div>
            <label for="inputEmail3" class="col-sm-1 col-form-label-sm">{{ $t("classification") }}</label>
            <div class="col-sm-2">
              <v-select :options="alltasks" label="name" v-model="thetask">
                <template #option="option">
                  <span>{{ option.name }}</span>
                </template>
              </v-select>
            </div>
            <label class="col-sm-1 col-form-label-sm">{{ $t("tax") }}</label>
            <div class="col-sm-1">
              <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="cofirmtax" />
            </div>
            <div class="col-sm-1">
              <button class="btn btn-primary" @click="Addproduct" style="padding: 1%">
                {{ $t("add") }} <i class="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <div class="part2">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th style="width: 3%">{{ $t("product") }}</th>
                  <th style="width: 3%">{{ $t("classification") }}</th>
                  <th>{{ $t("description") }}</th>
                  <th style="width: 10%">{{ $t("quantity") }}</th>
                  <th style="width: 10%">{{ $t("unit type") }}</th>
                  <th>{{ $t("discount") }}</th>
                  <th>{{ $t("price") }}</th>
                  <th>{{ $t("total") }} {{ $t("befor") }} {{ $t("tax") }}</th>
                  <th>{{ $t("tax") }}</th>
                  <th>{{ $t("amount") }} {{ $t("tax") }}</th>
                  <th>{{ $t("total") }}</th>
                  <th>{{ $t("cancel") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, id) in data" :key="value">
                  <td>{{ id + 1 }}</td>
                  <td style="width: 12%"><span>{{ value.barcode }} - {{ value.pronamear }}</span></td>
                  <td style="width: 12%"><span>{{ value.classname }}</span></td>
                  <td><input class="form-control form-control-sm" type="text" v-model="value.description" /></td>
                  <td><input class="form-control form-control-sm" type="text" v-model="value.quantity"
                      @change="updateCalculations(id)" /></td>
                  <td>{{ value.unittype }}</td>
                  <td style="display: flex">
                    <input type="number" v-model="value.amountdiscount" style="width: 70%"
                      @change="updateCalculations(id)" />
                  </td>
                  <td><input class="form-control form-control-sm" type="text" v-model="value.buyp"
                      @change="updateCalculations(id)" /></td>
                  <td>{{ value.tbt }}</td>
                  <td style="display: flex">
                    <input type="number" v-model="value.tax" style="width: 100px" @change="updateCalculations(id)" />%
                  </td>
                  <td>{{ value.taxamount }}</td>
                  <td>{{ value.total }}</td>
                  <td><a href="#" @click.prevent="del(id)"><i class="bi bi-x-circle-fill"></i></a></td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <div class="total">
            <h4>{{ $t("total") }}</h4>
            <div class="total1">المبلغ قبل الضريبة <input type="text" disabled v-model="tbt" /></div>
            <div class="total1">قيمة الضريبة <input type="text" disabled v-model="taxamount" /></div>
            <div class="total1">بعد الضريبة <input type="text" disabled v-model="total" /></div>
          </div>
          <hr />
          <div class="mb-2 row">
            <label for="inputEmail3" class="col-sm-1 col-form-label-sm">{{ $t("notes") }}</label>
            <div class="col-sm-5">
              <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="notes"></textarea>
            </div>
          </div>
          <!-- Existing Attachments Display -->
          <div class="mb-2 row" v-if="fileURLs.length > 0">
            <label for="existing-attachments" class="col-sm-1 col-form-label-sm">{{ $t("existing attachments") }}</label>
            <div class="col-sm-5">
              <ul class="attachment-list">
                <li v-for="(attachment, index) in fileURLs" :key="index">
                  <a :href="getAttachmentUrl(attachment.name)" target="_blank" class="attachment-link">
                    {{ attachment.name }}
                  </a>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="confirmRemoveAttachment(index, attachment.name)"
                    :disabled="isRemoving"
                  >
                    <span v-if="isRemoving && removingIndex === index" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span v-else>X</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <!-- New Attachments Input -->
          <div class="mb-2 row">
            <label for="attachments" class="col-sm-1 col-form-label-sm">{{ $t("new attachments") }}</label>
            <div class="col-sm-5">
              <input
                type="file"
                class="form-control"
                id="attachments"
                multiple
                @change="handleFiles($event)"
                :disabled="isRemoving"
              />
              <small v-if="attachments.length > 0">{{ attachments.length }} file(s) selected</small>
            </div>
          </div>
        </div>
      </div>
      </div>
    </template>

  <script>
  import store from "@/store";
  import useValidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import axios from "axios";
  import Swal from "sweetalert2";
  import { mapActions } from "vuex";
  import vSelect from "vue-select";

  export default {
    title: "Update Bill",
    components: { vSelect },
    props: ["css"],
    async mounted() {
      const billId = this.$route.params.id;
      await this.fetchBillData(billId);

      const result3 = await axios.get("/data/allsupplier");
      if (result3.status === 200) this.customers = result3.data.data;

      const result2 = await axios.get("/data/allproducts");
      if (result2.status === 200) this.products = result2.data.data;

      const result4 = await axios.get("/data/allprojects");
      const result5 = await axios.get("/data/alltasks");
      if (result4.status === 200) {
        this.allprojects = result4.data.data;
        this.alltasks = result5.data.data;
      }
    },
    data() {
      return {
        attachments: [], // New files selected by user
        fileURLs: [], // Existing attachments from backend
        disabled: false,
        isRemoving: false, // Track if an attachment is being removed
        removingIndex: null, // Track which attachment is being removed
        v$: useValidate(),
        id: "",
        data: [],
        date: "",
        description: "",
        customers: [],
        products: [],
        product: "",
        taxamount: 0,
        tbt: 0,
        total: 0,
        allprojects: [],
        alltasks: [],
        duedate: "",
        supplydate: "",
        sdata: "",
        project: "",
        thetask: "",
        cofirmtax: false,
        invnum: "",
        notes: "",
      };
    },
    validations() {
      return {
        date: { required },
        description: { required },
        project: { required },
        sdata: { required },
        invnum: { required },
      };
    },
    methods: {
      handleFiles(event) {
        this.attachments = Array.from(event.target.files);
      },
      getAttachmentUrl(name) {
        return `${store.state.imgurl}/bill_attachments/${name}`; // Adjust based on your server setup
      },
      async confirmRemoveAttachment(index, fileName) {
        const result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("You won't be able to revert this!"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("Yes, delete it!"),
          cancelButtonText: this.$t("Cancel"),
        });

        if (result.isConfirmed) {
          await this.removeAttachment(index, fileName);
        }
      },
      async removeAttachment(index, fileName) {
        this.isRemoving = true;
        this.removingIndex = index; // Track the specific attachment being removed
        try {
          const response = await axios.delete(`/projects/bill-attachments/${this.id}`, {
            data: {
              fileName: fileName,

            },
          });

          if (response.status === 200) {
            this.fileURLs.splice(index, 1); // Remove locally after successful server deletion
            Swal.fire({
              toast: true,
              position: "top",
              icon: "success",
              title: this.$t("Attachment deleted successfully"),
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          }
        } catch (error) {
          console.error("Error removing attachment:", error);
          Swal.fire({
            icon: "error",
            title: this.$t("Error"),
            text: error.response?.data?.message || this.$t("Failed to delete attachment"),
          });
        } finally {
          this.isRemoving = false;
          this.removingIndex = null;
        }
      },
      async fetchBillData(billId) {
        try {
          const response = await axios.get(`/data/bill/${billId}`);
          if (response.status === 200) {
            const bill = response.data.data;
            console.log("Fetched bill data:", bill);
            if (bill.review === "confirmed") {
              Swal.fire({
                icon: "error",
                title: "لا يمكن تعديل فاتورة مؤكدة",
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 3000,
              });
              this.redirectTo({ val: "AllProjectsBills" });
              return;
            }

            this.id = bill.bid;
            this.date = bill.due;
            this.description = bill.description;
            this.duedate = bill.duedate;
            this.invnum = bill.invnum;
            this.notes = bill.notes;
            this.data = JSON.parse(bill.details);
            this.tbt = bill.tbt;
            this.taxamount = bill.tax;
            this.total = bill.tat;
            this.sdata = { sid: bill.sid, name: bill.sname };
            this.project = {
              pid: bill.projectid,
              name: bill.project,
              ownername: bill.costname,
              ptype: bill.ptype,
              ownerid: bill.cid,
              commission: bill.pcom,
            };
            this.thetask = { tid: bill.taskid, name: bill.task };
            this.cofirmtax = bill.tax > 0;
            this.fileURLs = bill.attachments ? JSON.parse(bill.attachments) : [];
          }
        } catch (error) {
          console.error("Error fetching bill:", error);
          Swal.fire("Error", "Failed to fetch bill data", "error");
        }
      },
      updateCalculations(id) {
        const value = this.data[id];
        value.tbt =
          Number(
            value.buyp * value.quantity -
              (value.buyp * value.quantity * (value.discount || 0)) / 100
          ).toFixed(2) - (value.amountdiscount || 0);
        value.taxamount = Number((value.tbt * (value.tax || 0)) / 100).toFixed(2);
        value.total = Number(
          Number(value.tbt) + (value.tbt * (value.tax || 0)) / 100
        ).toFixed(2);
        this.calc();
      },
      calc() {
        this.tbt = this.data.reduce((acc, array) => acc + Number(array.tbt), 0);
        this.taxamount = this.data.reduce(
          (acc, array) => acc + Number(array.taxamount),
          0
        );
        this.total = this.data.reduce(
          (acc, array) => acc + Number(array.total),
          0
        );
      },
      async del(id) {
        this.data.splice(id, 1);
        this.calc();
      },
      Addproduct() {
        if (this.product && this.thetask && this.project) {
          const data2 = this.data.filter((x) => x.pronamear == this.product.namear);
          if (data2.length == 0) {
            if (this.cofirmtax) {
              this.data.push({
                proid: this.product.pid,
                pronamear: this.product.namear,
                pronameen: this.product.nameen,
                salep: this.product.salep,
                salec: this.product.salec,
                snamear: this.product.snamear,
                snameen: this.product.snameen,
                buyp: this.product.buyp,
                buyc: this.product.buyc,
                bnamear: this.product.bnamear,
                bnameen: this.product.bnameen,
                discount: this.product.discount || 0,
                unittype: this.product.unittype,
                tax: this.product.tax || 0,
                sn: this.product.sn,
                stock: this.product.stock,
                barcode: this.product.barcode,
                quantity: 1,
                tbt:
                  this.product.buyp * 1 -
                  (this.product.buyp * 1 * (this.product.discount || 0)) / 100,
                taxamount: Number(
                  ((this.product.buyp * 1 -
                    (this.product.buyp * 1 * (this.product.discount || 0)) / 100) *
                    (this.product.tax || 0)) /
                    100
                ).toFixed(2),
                total: Number(
                  this.product.buyp * 1 -
                    (this.product.buyp * 1 * (this.product.discount || 0)) / 100 +
                    ((this.product.buyp * 1 -
                      (this.product.buyp * 1 * (this.product.discount || 0)) / 100) *
                      (this.product.tax || 0)) /
                      100
                ).toFixed(2),
                classname: this.thetask.name,
                classid: this.thetask.tid,
                item: this.product.item,
                project: this.project.name,
                projectid: this.project.pid,
                amountdiscount: 0,
              });
            } else {
              this.data.push({
                proid: this.product.pid,
                pronamear: this.product.namear,
                pronameen: this.product.nameen,
                salep: this.product.salep,
                salec: this.product.salec,
                snamear: this.product.snamear,
                snameen: this.product.snameen,
                buyp: this.product.buyp,
                buyc: this.product.buyc,
                bnamear: this.product.bnamear,
                bnameen: this.product.bnameen,
                discount: this.product.discount || 0,
                unittype: this.product.unittype,
                tax: 0,
                sn: this.product.sn,
                stock: this.product.stock,
                barcode: this.product.barcode,
                quantity: 1,
                tbt:
                  this.product.buyp * 1 -
                  (this.product.buyp * 1 * (this.product.discount || 0)) / 100,
                taxamount: 0,
                total: Number(
                  this.product.buyp * 1 -
                    (this.product.buyp * 1 * (this.product.discount || 0)) / 100
                ).toFixed(2),
                classname: this.thetask.name,
                classid: this.thetask.tid,
                item: this.product.item,
                project: this.project.name,
                projectid: this.project.pid,
                amountdiscount: 0,
              });
            }
            this.calc();
          }
        }
      },
      async submit() {
        this.v$.$validate();
        if (!this.v$.$error && !this.isRemoving) {
          this.disabled = true;

          const billData = {
            username: store.state.randp.username,
            due: this.date,
            description: this.description,
            duedate: this.duedate,
            supplydate: this.supplydate || "",
            sid: this.sdata.sid,
            sname: this.sdata.name,
            ownername: this.project.ownername || "",
            details: JSON.stringify(this.data),
            tbt: this.tbt,
            tax: this.taxamount,
            tat: this.total,
            project: this.project.name,
            projectid: this.project.pid,
            projectowner: this.project.ownername,
            projectownerid: this.project.ownerid,
            task: this.thetask.name,
            taskid: this.thetask.tid,
            notes: this.notes,
            ptype: this.project.ptype,
            pcom: this.project.commission,
            invnum: this.invnum,
            attachments: JSON.stringify(this.fileURLs), // Updated attachments
          };

          try {
            // Step 1: Update bill data
            const updateResult = await axios.put(`/data/updateBill/${this.id}`, billData);
            if (updateResult.status === 200) {
              // Step 2: Upload new attachments if any
              if (this.attachments.length > 0) {
                for (let i = 0; i < this.attachments.length; i++) {
                  const file = this.attachments[i];
                  const formData = new FormData();
                  const nameParts = file.name.split(".");
                  const newName = `${store.state.randp.username}_${this.id}_${Date.now()}_${i}.${nameParts[nameParts.length - 1]}`;
                  formData.append("attachments", file, newName);

                  const uploadResult = await axios.patch(
                    `/bill-attachments/${this.id}`,
                    formData,
                    {
                      headers: { "Content-Type": "multipart/form-data" },
                    }
                  );

                  if (uploadResult.status === 200) {
                    this.fileURLs.push(...uploadResult.data.files); // Append new file metadata
                  } else {
                    console.error("File upload failed:", uploadResult);
                  }
                }

                // Step 3: Update bill with new file URLs
                if (this.attachments.length > 0) {
                  await axios.put(`/data/updateBill/${this.id}`, {
                    ...billData,
                    attachments: JSON.stringify(this.fileURLs),
                  });
                }
              }

              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", Swal.stopTimer);
                  toast.addEventListener("mouseleave", Swal.resumeTimer);
                },
              });
              Toast.fire({
                icon: "success",
                title: "Bill Updated successfully",
              });
              this.redirectTo({ val: "AllProjectsBills" });
            }
          } catch (error) {
            console.error("Error updating bill or uploading files:", error);
            Swal.fire({
              icon: "error",
              title: "Error updating bill",
              text: error.response?.data?.message || error.message,
            });
          } finally {
            this.disabled = false;
          }
        } else if (this.isRemoving) {
          Swal.fire({
            icon: "warning",
            title: this.$t("Please wait"),
            text: this.$t("An attachment is being removed"),
          });
        }
      },
      ...mapActions(["redirectTo"]),
    },
  };
  </script>

  <style lang="scss" scoped>
  .page {
    padding: 0.5%;
  }

  .main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    border-radius: 5px;
    border: ridge 0.5px;
  }

  .head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
  }

  .head1 {
    width: 70%;
  }

  input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
    text-align: center;
  }

  .head2 {
    width: 30%;
    text-align: center;
  }

  button {
    margin: 0.5%;
    padding: 2%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
  }

  .ccenter button {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
  }

  .head2 button a {
    color: white;
  }

  .table {
    margin-top: 1%;
  }

  table thead tr {
    border-radius: 5px;
    background-color: #eee;
  }

  select {
    width: 20%;
    margin: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }

  .part1 {
    display: flex;
    width: 100%;
  }

  .part11 {
    width: 50%;
    padding: 2%;
  }

  .part12 {
    width: 50%;
    padding: 2%;
  }

  .attachment-list {
    list-style: none;
    padding: 0;
  }

  .attachment-list li {
    display: flex;
    align-items: center;
    margin: 5px 0;
  }

  .attachment-link {
    color: #007bff;
    text-decoration: none;
    margin-right: 10px;
  }

  .attachment-link:hover {
    text-decoration: underline;
  }

  .btn-sm {
    padding: 2px 5px;
    font-size: 12px;
  }

  .btn-sm:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media screen and (max-width: 576px) {
    .table {
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      background-color: white;
      font-size: xx-small;
    }
  }
  </style>
